<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      resizable
      auto-resize
      show-footer-overflow
      cell-class-name="align-top"
      :columns="tableColumns"
      :loading="loading"
      :data="tableData"
      :max-height="tableHeight - 200"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .col--edit .vxe-cell {
    padding: 7px 0;
  }
  .vxe-body--column.displayFactory:not(.col--actived) .vxe-cell,
  .vxe-body--column.replyQty:not(.col--actived) .vxe-cell {
    padding-top: 0;
    padding-bottom: 0;
  }
  .col--seq:not(.vxe-header--column) .vxe-cell {
    margin-top: 7px;
    padding-left: 4px;
    padding-right: 4px;
  }

  .vxe-body--column:not(.col--edit) {
    .el-descriptions-item__container {
      line-height: 27px;
      .el-descriptions-item__label:empty {
        display: none;
      }
      .el-descriptions-item__content {
        flex: 1;
      }
      .el-descriptions-item__label:not(.is-bordered-label) {
        margin-right: 5px;
      }
    }
  }

  .el-descriptions-item__container {
    line-height: 27px;
    .el-descriptions-item__label:empty {
      display: none;
    }
    .el-descriptions-item__content {
      flex: 1;
    }
    .el-descriptions-item__label:not(.is-bordered-label) {
      margin-right: 5px;
    }
  }

  .vxe-body--column:not(.col--edit) {
    .el-descriptions-item__container {
      line-height: 1.5;
    }
  }
}
</style>
